var Curriculog = Curriculog || {};

Curriculog.ManageUserView = (function ($, _, Backbone, ManageUserView) {

	ManageUserView = Curriculog.CurriculogView.extend({
		template: 'HierarchyFlyout/manageUser.html',
		events: {
			'blur #user-details-firstName': 'changeFirstName',
			'blur #user-details-lastName': 'changeLastName',
			'blur #user-details-email': 'changeEmail',
			'blur #user-details-userName': 'changeUserName',
			'click #user-details-isRemote': 'changeIsRemote',
			'click #user-details-status': 'changeStatus',
			'click #save-user': 'updateUser',
			'click #delete-user': 'deleteUser',
			'click #cancel-user': 'resetForm',
		},


		initialize: function (options) {
			this.user = options.user;
			this.tempChanges = this.user.clone();
			this.render();
		},

		render: function () {
			templateData = {
				user: this.user.toJSON(),
			};

			this.el = nunjucks.render(this.template, templateData);
			this.replaceElement(this.el);
		},

		changeFirstName: function (event) {
			var firstName = $('#user-details-firstName').val();
			this.tempChanges.set('first_name', firstName);
		},

		changeLastName: function (event) {
			var lastName = $('#user-details-lastName').val();
			this.tempChanges.set('last_name', lastName);
		},

		changeEmail: function (event) {
			var email = $('#user-details-email').val();
			this.tempChanges.set('email', email);
		},

		changeUserName: function (event) {
			var userName = $('#user-details-userName').val();
			this.tempChanges.set('user_name', userName);
		},

		changeIsRemote: function (event) {
			var checkbox = event.target;
			if (checkbox.checked === false) {
				this.tempChanges.set('is_remote', 0);
				$('.remote-options').attr('style', 'display: none;')
				$('.local-options').attr('style', 'display: block;')
			} else {
				this.tempChanges.set('is_remote', 1);
				$('.remote-options').attr('style', 'display: block;')
				$('.local-options').attr('style', 'display: none;')
			}
		},

		changeStatus: function (event) {
			var checkbox = event.target;
			if (checkbox.checked === false) {
				this.tempChanges.set('status', 'inactive');
			} else {
				this.tempChanges.set('status', 'active');
			}
		},

		updateUser: function () {
			var view = this;
			var userChanges = this.tempChanges.toJSON();

			this.user.save(userChanges, {
				wait: true,

				error: function () {
					view.resetForm();

					var errorText = 'An error was encountered when updating the user information.  ';
					errorText += 'The user has not been updated.  Please try again ';
					errorText += 'or contact an administrator.';
					this.showGrowl(errorText);
				},
			});
		},

		resetForm: function () {
			$('#user-details-firstName').val(this.user.get('first_name'));
			$('#user-details-lastName').val(this.user.get('last_name'));
			$('#user-details-email').val(this.user.get('email'));
			$('#user-details-userName').val(this.user.get('user_name'));

			if (this.user.get('is_remote') === 0) {
				$('#user-details-isRemote').prop('checked', false);
				$('.remote-options').attr('style', 'display: none;')
				$('.local-options').attr('style', 'display: block;')
			} else {
				$('#user-details-isRemote').prop('checked', true);
				$('.remote-options').attr('style', 'display: block;')
				$('.local-options').attr('style', 'display: none;')
			}

			if (this.user.get('status') === 'active') {
				$('#user-details-status').prop('checked', true);
			} else {
				$('#user-details-status').prop('checked', false);
			}
		},

		deleteUser: function () {
			var user = {
				id : this.user.get('id'),
				name : this.user.name(),
				type: 'user'
			};

			accountObject.swapAccountRole(user);
		},
	});
	return ManageUserView;

})($, _, Backbone, Curriculog.ManageUserView || {});
